import { Toaster as Sonner } from "sonner"

const Toaster = ({ ...props }) => {
    return (
        <Sonner
            theme="dark"
            className="toaster group"
            expand
            closeButton
            toastOptions={{
                closeButton: true,
                classNames: {
                    toast:
                        "group toast group-[.toaster]:bg-surface group-[.toaster]:text-foreground-strong group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-foreground-muted",
                    actionButton:
                        "group-[.toast]:bg-cyan-600 group-[.toast]:text-white",
                    cancelButton:
                        "group-[.toast]:bg-surface-active group-[.toast]:text-foreground-muted",
                    closeButton:
                        "!opacity-100 !absolute !-top-2 !-right-2 !left-auto !bg-surface-active !text-white !border !border-border-strong hover:!bg-border-strong !rounded-full !w-6 !h-6 !flex !items-center !justify-center !shadow-md !transform-none !z-50",

                },
            }}
            {...props}
        />
    )
}

export { Toaster }
